module.exports = __webpack_public_path__ + "static/media/7.42c8b70b.jpg";